import PropTypes from 'prop-types'

export const resultItem = PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  budget: PropTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
  wishlisted: PropTypes.bool.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['apartment', 'hotel', 'villa']).isRequired,
  bedrooms: PropTypes.number.isRequired,
  beds: PropTypes.number.isRequired,
  distance: PropTypes.number.isRequired,
})

export const searchResults = PropTypes.shape({
  count: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  amenities: PropTypes.objectOf(PropTypes.number.isRequired).isRequired,
  types: PropTypes.shape({
    apartment: PropTypes.number.isRequired,
    hotel: PropTypes.number.isRequired,
    villa: PropTypes.number.isRequired,
  }).isRequired,
  results: PropTypes.arrayOf(resultItem).isRequired,
})

export const searchAppConfig = {
  isLoadedForBookingManagementView: PropTypes.string.optional,
  companyIdForBookingManagmentView: PropTypes.number.optional,
  endpoint: PropTypes.string.isRequired,
  wishlistToggleEndpoint: PropTypes.string.isRequired,
  googleApiKey: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
  eventUUID: PropTypes.string.isRequired,
  eventTitle: PropTypes.string.isRequired,
  eventCity: PropTypes.string.isRequired,
  map: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  amenities: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  data: searchResults,
  filters: PropTypes.shape({
    types: PropTypes.arrayOf(PropTypes.oneOf(['apartment', 'hotel', 'villa'])),
    minBedrooms: PropTypes.number,
    maxBedrooms: PropTypes.number,
    minBeds: PropTypes.number,
    maxBeds: PropTypes.number,
    minBudget: PropTypes.number,
    maxBudget: PropTypes.number,
    amenities: PropTypes.arrayOf(PropTypes.string),
  }),
  order: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/utils/propTypes.js